import { z } from 'zod';

export const UvUnwrappingSchema = z
  .object({
    method: z.union([
      z.literal('cube'),
      z.literal('isometric'),
      z.literal('forwardBijective'),
      z.literal('fixedBoundary'),
      z.literal('fastConformal'),
    ]),
    uvScale: z.number().gte(0.001).lte(100).optional(),
  })
  .optional();
